<script>
const BaseOverview = () => import('../components/detail/BaseOverview')

export default {
  props: {
    name: {
      type: String,
      default: ''
    },

    amount: {
      type: Number,
      default: 0
    },

    importAmount: {
      type: Number,
      default: 0
    },

    exportAmount: {
      type: Number,
      default: 0
    },

    start: {
      type: Date,
      default: null
    },

    end: {
      type: Date,
      default: null
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    period: {
      get() {
        if (!this.start || !this.end) return null

        return [this.start, this.end]
      },

      set(value) {
        let start, end

        if (value) {
          ;[start, end] = value
        } else {
          ;[start, end] = [null, null]
        }

        this.$emit('update:start', start)
        this.$emit('update:end', end)
      }
    }
  },

  methods: {
    handlePeriodChange(value) {
      this.$emit('submit', value)
    }
  },

  render() {
    return (
      <BaseOverview
        name={this.name}
        period={this.period}
        amount={this.amount}
        importAmount={this.importAmount}
        exportAmount={this.exportAmount}
        unit="กรัม"
        mq={this.$mq}
        format="0,0.00"
        loading={this.loading}
        on={{
          'update:period': value => {
            this.period = value
          },
          'change:period': this.handlePeriodChange
        }}
      />
    )
  }
}
</script>
